/**
 * Opt-in environment banner for isolated demo builds.
 * Enabled only when REACT_APP_ENVIRONMENT_BANNER is set at build time.
 */

import './EnvironmentBanner.css';

const BANNER_TEXT = (process.env.REACT_APP_ENVIRONMENT_BANNER || '').trim();

export function getEnvironmentBannerText() {
  return BANNER_TEXT;
}

export default function EnvironmentBanner() {
  if (!BANNER_TEXT) {
    return null;
  }

  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="environment-banner"
      className="environment-banner"
    >
      {BANNER_TEXT}
    </div>
  );
}
